
export default {
    name: 'MenuItem',

    props: {
        item: {
            type: Object,
            default: () => ({}),
        },
    },

    data() {
        return {
            isOpen: false,
        };
    },

    computed: {
        childrenList() {
            return (this.item?.children || []).filter((t) => !t.isHidden);
        },
        isChildren() {
            return (this.childrenList || []).length > 0;
        },
    },

    methods: {
        clickLink() {
            if (!this.isChildren) {
                this.$router.push(`/${this.item.path}`);
                return;
            }

            this.$refs.refMenuItem.classList.remove('--hover');
            setTimeout(() => {
                this.$refs.refMenuItem.classList.add('--hover');
            }, 100);
        },
    },
};
